import { QuizQuestionProps } from "@/pages/quiz/context/types";
import { Button } from "@/pages/quiz/15000/components/Button";
import beforeBanner from "@/assets/images/v4/before.webp";
import afterBanner from "@/assets/images/v4/after.webp";

const RealUsersRealResultsBanner = ({
  setQuestionAnswer,
}: QuizQuestionProps<boolean>) => {
  const title = "Real Users, Real Results.";

  return (
    <>
      <p className="text-4xl mb-6 text-new-design-gray-500 font-medium whitespace-normal break-keep hyphens-none">
        {title}
      </p>

      <div className="max-h-[550px] mx-auto w-full flex gap-2 overflow-hidden sm:gap-4">
        <img
          src={beforeBanner}
          alt="Real Users, Real Results"
          className="flex-1 min-w-0 h-auto object-contain"
        />

        <img
          src={afterBanner}
          alt="Real Users, Real Results"
          className="flex-1 min-w-0 h-auto object-contain"
        />
      </div>

      <Button onClick={() => setQuestionAnswer(true)} />
    </>
  );
};

export { RealUsersRealResultsBanner };
